<template>
  <div class="component">
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <h5 class="card-title mt-1">{{!machine.id ? 'Nova' : 'Editar'}} Máquina</h5>
                </div>
              </div>
              <hr />

              <div class="form-group">
                <label for="name">
                  Nome:
                  <span v-if="required('name')">*</span>
                </label>
                <input
                  name="name"
                  type="text"
                  v-model="machine.name"
                  class="form-control"
                  v-bind:class="{'input-error': showError('name')}"
                  :disabled="!canAccess()"
                />
                <div class="general-error" v-if="showError('name')">O campo Nome é necessário.</div>
              </div>
              
              <div class="form-group">
                <label for="name">
                  Tipo:
                  <span v-if="required('type')">*</span>
                </label>
                <input
                  name="type"
                  type="text"
                  v-model="machine.type"
                  class="form-control"
                  v-bind:class="{'input-error': showError('type')}"
                  :disabled="!canAccess()"
                />
                <div class="general-error" v-if="showError('type')">O campo Tipo é necessário.</div>
              </div>

              <div class="form-group">
                <label for="name">
                  Capacidade:
                  <span v-if="required('capacity')">*</span>
                </label>
                <input
                  name="capacity"
                  type="text"
                  v-model="machine.capacity"
                  class="form-control"
                  v-bind:class="{'input-error': showError('capacity')}"
                  :disabled="!canAccess()"
                />
                <div
                  class="general-error"
                  v-if="showError('capacity')"
                >O campo Capacidade é necessário.</div>
              </div>

              <div class="form-group">
                <label for="name">
                  Tensão:
                  <span v-if="required('tension')">*</span>
                </label>
                <input
                  name="tension"
                  type="text"
                  v-model="machine.tension"
                  class="form-control"
                  v-bind:class="{'input-error': showError('tension')}"
                  :disabled="!canAccess()"
                />
                <div class="general-error" v-if="showError('tension')">O campo Tensão é necessário.</div>
              </div>

              <div class="form-group">
                <label for="name">
                  Fabricante:
                  <span v-if="required('manufacturer')">*</span>
                </label>
                <input
                  name="manufacturer"
                  type="text"
                  v-model="machine.manufacturer"
                  class="form-control"
                  v-bind:class="{'input-error': showError('manufacturer')}"
                  :disabled="!canAccess()"
                />
                <div
                  class="general-error"
                  v-if="showError('manufacturer')"
                >O campo Fabricante é necessário.</div>
              </div>

              <div class="form-group">
                <label for="name">
                  Número de Série:
                  <span v-if="required('serie_number')">*</span>
                </label>
                <input
                  name="serie_number"
                  type="text"
                  v-model="machine.serie_number"
                  class="form-control"
                  v-bind:class="{'input-error': showError('serie_number')}"
                  :disabled="!canAccess()"
                />
                <div
                  class="general-error"
                  v-if="showError('serie_number')"
                >O campo Número de Série é necessário.</div>
              </div>

              <div class="form-group">
                <label for="name">
                  Ano de Fabricação: (Caso não identificado, deixar em branco)
                  <span v-if="required('manufactured_at')">*</span>
                </label>
                <input
                  name="manufactured_at"
                  type="text"
                  v-mask="'####'"
                  v-model="machine.manufactured_at"
                  class="form-control"
                  v-bind:class="{'input-error': showError('manufactured_at')}"
                  :disabled="!canAccess()"
                />
                <div
                  class="general-error"
                  v-if="showError('manufactured_at')"
                >O campo Ano de Fabricação é necessário.</div>
              </div>

              <div class="form-group">
                <label for="name">
                  Função da Máquina:
                  <span v-if="required('machine_function')">*</span>
                </label>
                <input
                  name="machine_function"
                  type="text"
                  v-model="machine.machine_function"
                  class="form-control"
                  v-bind:class="{'input-error': showError('machine_function')}"
                  placeholder="A máquina tem sua única e exclusiva função de..."
                  :disabled="!canAccess()"
                />
                <div
                  class="general-error"
                  v-if="showError('machine_function')"
                >O campo Função da Máquina é necessário.</div>
              </div>

              <div class="form-group">
                <label for="name" v-if="!machine.id">
                  Foto:
                  <span v-if="required('photo_id')">*</span>
                </label>
                <label for="name" v-if="machine.id">Alterar Foto:</label>

                <div class="d-flex justify-content-between mb-3">
                  <b-form-file
                    v-model="machine.photo_id"
                    placeholder="Escolha um arquivo"
                    drop-placeholder="Arraste o arquivo aqui..."
                    browse-text="Procurar"
                    accept="image/jpeg, image/png, image/jpg"
                    v-bind:class="{'input-error': showError('photo_id'), 'col-8': machine.id, 'col-12': !machine.id}"
                    v-on:change="uploadImage"
                    :disabled="!canAccess()"
                  ></b-form-file>
                  <button
                    v-if="machine.id"
                    class="btn btn-secondary col-3"
                    @click="showDirectoryModal"
                    :disabled="!canAccess()"
                  >
                    Selecionar do arquivo
                  </button>
                </div>
                <div v-if="imagePreviewUrl">
                    <img width="200" style="margin-top: 10px;" :src="imagePreviewUrl" alt="Preview" class="image-rounded">
                </div>

                <div class="general-error" v-if="showError('photo_id')">O campo Foto é necessário.</div>
              </div>

              <div class="form-group" v-if="photo">
                <div class="card-photo d-flex justify-content-center w-100">
                  <img
                    :src="tempImage ? tempImage : photo.url"
                    style="width: 35%; height: auto; margin-top: 20px;"
                    class="image image-rounded"
                  />
                </div>
              </div>
              <div class="form-group">
                <div v-if="photoGallery && photoGallery.length > 0" class="photo-gallery mt-3">
                  <div style="display: flex; align-items: center; gap: 5px;" class="mb-3">
                    <span>Galeria de fotos</span>
                    <GalleryDownloadProgress
                      v-if="downloadProgress"
                      :current="downloadProgress.current"
                      :total="downloadProgress.total"
                    />
                    <b-dropdown v-else variant="link" no-caret>
                      <template v-slot:button-content>
                        <font-awesome-icon icon="download" color="#007bff"/>
                      </template>
                      <b-dropdown-item @click="handleDownload(true)">Galeria HD</b-dropdown-item>
                      <b-dropdown-item @click="handleDownload(false)">Galeria SD</b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <div ref="galleryContainer" class="" style="display: flex; overflow: auto; margin-right: 15px; margin-left: 15px;">
                    <div v-for="(photo, index) in photoGallery" :key="photo.id || index" class="col-md-2 mb-3">
                      <img
                        ref="galleryPhoto"
                        :data-idx="index"
                        :src="gallerySrc(photo, index)"
                        class="img-thumbnail"
                        :class="{ 'gallery-photo-pending': !loadedPhotos[index] }"
                        style="width: 100%; height: 150px; object-fit: cover;"
                        :alt="'Gallery image ' + (index + 1)"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group" v-if="showCompaniesSelect">
                <label for="name">
                  Unidade
                  <span v-if="required('company_id')">*</span>
                </label>
                <select
                  v-model="machine.company_id"
                  id
                  class="form-control"
                  v-bind:class="{'input-error': showError('company_id')}"
                  :disabled="machine.id"
                >
                  <option
                    v-for="company in companies"
                    v-bind:key="company.id"
                    :value="company.id"
                  >{{company.corporate_name}}</option>
                </select>
                <div class="general-error" v-if="showError('company_id')">O campo Unidade é necessário.</div>
              </div>

              <div class="form-group">
                <label for="name">
                  Setor
                  <span v-if="required('sector')">*</span>
                </label>

                <input
                  name="serie_number"
                  type="text"
                  v-model="machine.sector"
                  class="form-control"
                  v-bind:class="{'input-error': showError('sector')}"
                />
                <div class="general-error" v-if="showError('sector')">O campo Setor é necessário.</div>
              </div>

              <div class="form-group">
                <label for="observations">
                  Observações
                </label>
                <textarea
                  v-model="machine.observations"
                  class="form-control"
                  v-bind:class="{'input-error': showError('observations')}"
                  :disabled="!canAccess()"
                ></textarea>
              </div>

              <div class="row">
                <div class="col-6"></div>
                <div class="col-6" v-if="canAccess()">
                  <button
                    type="button"
                    class="btn btn-success float-right"
                    v-on:click="save()"
                  ><span>Salvar  <font-awesome-icon icon="save" /> </span></button>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-padding">
                  <b-alert
                    v-show="success"
                    variant="success"
                    show
                  >Máquina {{!machine.id ? 'Criada' : 'Salva'}} com sucesso!</b-alert>
                  <b-alert v-if="warning && errorMessage" variant="warning" show>{{ errorMessage }}</b-alert>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal 
      id="directory-modal"
      ref="directoryModal"
      title="Selecionar Arquivo"
      size="lg"
      :hide-footer="false"
      @ok="selectImageFromDirectory"
    >
      <div class="container-fluid">
        <div class="row" style="font-size: 18px; margin-bottom: 8px">
          <div class="col-6">
            <font-awesome-icon
              style="margin-right: 8px; color: #f2671c"
              icon="folder-open"
            />
            <span>{{ folder.name ? folder.name : "Diretórios" }}</span>
          </div>
          <div class="col-6">
            <div class="w-100 d-flex justify-content-end">
              <div
                class="return"
                v-if="folder.id"
                v-on:click="
                  openFolder(
                    folder.ancestor ? folder.ancestor.id : 'root'
                  )
                "
              >
                <font-awesome-icon icon="angle-left" />Voltar
              </div>
            </div>
          </div>
        </div>
        <div
          class="row"
          style="max-height: 60vh; overflow: auto"
          v-if="renderFolders"
        >
          <div
            class="col-12"
            v-for="subFolder in folder.descendants"
            v-bind:key="subFolder.id"
            v-on:click="openFolder(subFolder.id)"
          >
            <FolderItem
              type="folder"
              :name="subFolder.name"
              :id="subFolder.id"
            ></FolderItem>
          </div>
          <div
            class="col-12"
            v-for="file in folder.attachments"
            v-bind:key="file.id"
          >
            <FolderItem
              type="file"
              :name="file.name"
              :size="formatNumber(file.size / 1000) + 'KB'"
              :id="file.id"
              :url="file.url"
              :mimeType="file.mime_type"
              canSelect
              :selected="isSelectedItem(file.id)"
              @selectItem="selectItem"
            ></FolderItem>
          </div>
        </div>
        <div
          v-if="!renderFolders"
          class="w-100 d-flex justify-content-center align-items-center"
          style="margin-top: 30px; margin-bottom: 30px"
        >
          <b-spinner
            style="margin-right: 15px"
            label="Small Spinner"
          ></b-spinner>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import axios from "@/api/axios";
import FolderItem from "@/components/FolderItem.vue";
import GalleryDownloadProgress from "@/components/GalleryDownloadProgress.vue";
import { canAccess } from "@/utils/canAccess";
import { downloadGallery, getHdFallbackNotice } from "@/utils/downloadGallery";
import { required } from "vuelidate/lib/validators";

export default {
  name: "Machines_New",
  components: {
    FolderItem,
    GalleryDownloadProgress
  },
  props: {
    id: String
  },
  data() {
    return {
      errorMessage: '',
      address: {},
      machine: {},
      group: {},
      companies: [],
      imagePreviewUrl: '',
      submited: false,
      success: false,
      warning: false,
      photo: null,
      tempImage: "",
      role: localStorage.getItem("auth.role"),
      email: localStorage.getItem("auth.email"),
      items: [
        {
          text: "Documentos",
          href: "#/admin/Documents/Index",
        },
        // ...(localStorage.getItem("companyName")
        //   ? [
        //       {
        //         text: localStorage.getItem("companyName"),
        //         href: `#/admin/Documents/Company?company_id=${localStorage.getItem("company_id")}`,
        //         active: false,
        //       },
        //     ]
        //   : []),
        {
          text: "Máquinas",
          href: `#/admin/Machines/ListMachines`,
        },
        {
          text: "Máquina",
          active: true,
        },
      ],
      photoGallery: [],
      loadedPhotos: [],
      galleryObserver: null,
      placeholderSrc: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==",
      downloadProgress: null,
      folder: {},
      renderFolders: true,
      existsAttachmentList: [],
      localCompanyId: localStorage.getItem('company_id'),
      company_id: localStorage.company_id
    };
  },
  computed: {
    companyIdQuery() {
      return this.$route.query['company-id'];
    },
    localCorporateGroupId() {
      return this.$route.query['corporate-group-id'] || localStorage.getItem('corporate_group_id');
    },
    showCompaniesSelect() {
      return this.companyIdQuery ? false : true;
    },
  } ,
  mounted: async function() {
    const loader = this.$loading.show();
    if (this.id) {
      await this.getMachine();
    }
    if (this.companyIdQuery) {
      this.companies = [{
        id: this.companyIdQuery,
      }]
      this.machine.company_id = this.companyIdQuery;
    } else {
      await this.getCompaniesByCorporateGroupId();
    }
    loader.hide();
  },
  beforeDestroy() {
    this.teardownGalleryObserver();
  },
  watch: {
    photoGallery() {
      this.loadedPhotos = this.photoGallery.map(() => false);
      this.$nextTick(() => this.initGalleryObserver());
    },
  },
  validations: {
    machine: {
      name: {
        required
      },
      type: {},
      capacity: {},
      tension: {},
      manufacturer: {},
      manufactured_at: {},
      serie_number: {},
      photo_id: {
        required
      },
      sector: {
        required
      },
      company_id: {
        required
      },
      observations: {

      },
      machine_function: {}
    }
  },
  methods: {
    canAccess,
    goToMachine(id) {
      this.$router.push({ name: 'Filtered_Machine', params: { id } });
    },
    async handleDownload(hd) {
      try {
        const summary = await downloadGallery(this.photoGallery, `${this.machine.name}`, {
          hd,
          onProgress: (progress) => {
            this.downloadProgress = progress;
          },
        });
        const notice = getHdFallbackNotice(summary);
        if (notice) {
          this.$bvToast.toast(notice, {
            title: "Download da galeria",
            toaster: "b-toaster-top-center",
            solid: true,
            variant: "warning",
            autoHideDelay: 8000,
          });
        }
      } finally {
        this.downloadProgress = null;
      }
    },
    previewImage(file) {
      if (file) {
        this.readFile(file);
      }
    },
    readFile(file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.imagePreviewUrl = event.target.result;
      };
      reader.readAsDataURL(file);
    },

    getCompaniesByCorporateGroupId: async function (){
      const response = await axios.get(`${process.env.VUE_APP_API_HOST}/api/admin/companies?${this.localCorporateGroupId ? `filter[corporate_group.id]=${this.localCorporateGroupId}`:''}`,
        {
          params: {
            not_paginated: true,
            user_email: this.email,
            user_role: this.role,
            reduced: true,
          },
        }
      )
      this.companies = response.data.data;
    },

    save: function() {
      this.submited = true;
      if (!this.$v.$invalid) {
        if (!this.machine.id) {
          const loader = this.$loading.show();
          axios
            .post(`${process.env.VUE_APP_API_HOST}/api/admin/machines`, {
              name: this.machine.name,
              type: this.machine.type,
              capacity: this.machine.capacity,
              manufacturer: this.machine.manufacturer,
              tension: this.machine.tension,
              manufactured_at: this.machine.manufactured_at,
              serie_number: this.machine.serie_number,
              image: this.tempImage,
              sector: this.machine.sector,
              company_id: this.machine.company_id,
              observations: this.machine.observations,
              machine_function: this.machine.machine_function
            })
            .then(response => {
              localStorage.setItem('machine_success_notification', 'true');
              
              setTimeout(() => {
                this.success = false;
                this.$router.push({ name: 'Machines_List', params: { company_id: this.companyIdQuery } });
              }, 1500);
              return response.data;
            })
            .catch((error) => {
              if (error.response && error.response.status === 422) {
              // Captura e armazena a mensagem de erro 422
              const errors = error.response.data.errors;

              // Verifica se há um erro específico para o campo `name`
              if (errors && errors.name) {
                this.errorMessage = errors.name[0]; // Armazena a primeira mensagem de erro para `name`
              } else {
                this.errorMessage = error.response.data.message || 'Ocorreu um erro ao salvar a máquina.';
              }
            } else {
              this.errorMessage = 'Ocorreu um erro inesperado.';
            }
              this.warning = true;
            }).finally(() => loader.hide());
        } else {
          this.edit();
        }
      }
    },
    edit: function() {
      const loader = this.$loading.show();
      axios
        .put(
          `${process.env.VUE_APP_API_HOST}/api/admin/machines/` +
            this.machine.id,
          {
            name: this.machine.name,
            type: this.machine.type,
            capacity: this.machine.capacity,
            manufacturer: this.machine.manufacturer,
            tension: this.machine.tension,
            manufactured_at: this.machine.manufactured_at,
            serie_number: this.machine.serie_number,
            sector: this.machine.sector,
            company_id: this.machine.company_id,
            observations: this.machine.observations,
            image: this.tempImage,
            machine_function: this.machine.machine_function
          }
        )
        .then(response => {
          localStorage.setItem('machine_success_notification', 'true');
          
          setTimeout(() => {
            this.success = false;
            this.$router.push({ name: "Machines_List" , params: { company_id: this.companyIdQuery }});
          }, 1500);
          return response.data;
        })
        .catch((error) => {
              if (error.response && error.response.status === 422) {
              // Captura e armazena a mensagem de erro 422
              const errors = error.response.data.errors;

              // Verifica se há um erro específico para o campo `name`
              if (errors && errors.name) {
                this.errorMessage = errors.name[0]; // Armazena a primeira mensagem de erro para `name`
              } else {
                this.errorMessage = error.response.data.message || 'Ocorreu um erro ao salvar a máquina.';
              }
            } else {
              this.errorMessage = 'Ocorreu um erro inesperado.';
            }
              this.warning = true;
        }).finally(() => loader.hide());
    },
    showError: function(attribute) {
      return this.$v.machine[attribute].$invalid && this.submited;
    },
    required: function(attribute) {
      return this.$v.machine[attribute].$params.required;
    },
    gallerySrc(photo, index) {
      return this.loadedPhotos[index] ? photo.url : this.placeholderSrc;
    },
    initGalleryObserver() {
      this.teardownGalleryObserver();
      const container = this.$refs.galleryContainer;
      const photos = this.$refs.galleryPhoto || [];
      if (!container || !photos.length) return;

      if (!("IntersectionObserver" in window)) {
        this.loadedPhotos = this.photoGallery.map(() => true);
        return;
      }

      this.galleryObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const idx = Number(entry.target.dataset.idx);
            if (!Number.isNaN(idx)) this.$set(this.loadedPhotos, idx, true);
            this.galleryObserver.unobserve(entry.target);
          });
        },
        // Observa dentro do scroll lateral da galeria (não da janela) e com folga
        // horizontal, pra foto começar a carregar um pouco antes de entrar na área visível
        { root: container, rootMargin: "0px 200px", threshold: 0.01 }
      );
      photos.forEach(el => this.galleryObserver.observe(el));
    },
    teardownGalleryObserver() {
      if (!this.galleryObserver) return;
      this.galleryObserver.disconnect();
      this.galleryObserver = null;
    },
    getMachine: function() {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/admin/machines/${this.id}?include=photo,company`
        )
        .then(response => {
          this.machine = response.data.data;
          this.photo = this.machine.photo;
          
          // Ordenar galeria de fotos por data de criação (mais antigas primeiro)
          if (this.machine.photo_gallery && this.machine.photo_gallery.length > 0) {
            this.photoGallery = this.machine.photo_gallery.sort((a, b) => {
              // Se não tiver created_at, usar id como fallback (assumindo que id crescente = ordem cronológica)
              const dateA = a.created_at ? new Date(a.created_at) : new Date(a.id);
              const dateB = b.created_at ? new Date(b.created_at) : new Date(b.id);
              return dateA - dateB; // Ordem crescente (mais antiga primeiro)
            });
          } else {
            this.photoGallery = [];
          }
        });
    },
    uploadImage: function(e) {
      const file = e.target.files[0];
      this.previewImage(file);

      if (!file.type.includes("image/")) {
        return;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = event => {
          this.tempImage = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    showDirectoryModal() {
      this.getFolders();
      this.$refs.directoryModal.show();
    },
    getFolders: function () {
      this.renderFolders = false;
      let url = this.machine.id
        ? `${process.env.VUE_APP_API_HOST}/api/admin/directories?filter[machine_id]=${this.machine.id}&filter[where_is_root]=1`
        : `${process.env.VUE_APP_API_HOST}/api/admin/directories?filter[company_id]=${this.company_id}&filter[where_is_root]=1`;
        
      axios
        .get(url, {
          params: {
            page: 1,
            per_page: 100,
          },
        })
        .then((response) => {
          this.folder.descendants = response.data.data;
          this.folder.attachments = [];
          this.renderFolders = true;
        })
        .catch(() => {
          this.renderFolders = true;
          this.$bvToast.toast(
            `Desculpe, tivemos algum problema. Por favor tente novamente!`,
            {
              title: `Ocorreu um erro`,
              toaster: "b-toaster-top-center",
              solid: true,
              variant: "danger",
            }
          );
        });
    },
    openFolder: function (folder_id) {
      if (folder_id == "root") {
        this.folder = {};
        return this.getFolders();
      }
      this.renderFolders = false;
      axios
        .post(
          `${process.env.VUE_APP_API_HOST}/api/admin/get-attachments-by-machine`,
          { directory_id: folder_id, machine_id: this.machine.id }
        )
        .then((response) => {
          this.folder = response.data;
          this.renderFolders = true;
        })
        .catch(() => {
          this.renderFolders = true;
          this.$bvToast.toast(
            `Desculpe, tivemos algum problema. Por favor tente novamente!`,
            {
              title: `Ocorreu um erro`,
              toaster: "b-toaster-top-center",
              solid: true,
              variant: "danger",
            }
          );
        });
    },
    formatNumber(n) {
      let t = parseFloat(n).toFixed(1);
      return t.replace(".", ",");
    },
    selectItem(id, value) {
      if (value) {
        this.existsAttachmentList.push(id);
      } else {
        let index = this.existsAttachmentList.indexOf(id);
        this.existsAttachmentList.splice(index, 1);
      }
    },
    isSelectedItem(id) {
      return this.existsAttachmentList.indexOf(id) >= 0;
    },
    selectImageFromDirectory() {
      if (this.existsAttachmentList.length > 0) {
        axios
          .get(
            `${process.env.VUE_APP_API_HOST}/api/admin/attachments/${this.existsAttachmentList[0]}`
          )
          .then((response) => {
            const imageUrl = response.data.data.url;
            this.imagePreviewUrl = imageUrl;
            
            // Convert image URL to base64
            fetch(imageUrl)
              .then(response => response.blob())
              .then(blob => {
                const reader = new FileReader();
                reader.onloadend = () => {
                  this.tempImage = reader.result;
                  this.existsAttachmentList = [];
                  this.$refs.directoryModal.hide();
                };
                reader.readAsDataURL(blob);
              })
              .catch(() => {
                this.$bvToast.toast(
                  `Desculpe, tivemos algum problema ao converter a imagem. Por favor tente novamente!`,
                  {
                    title: `Ocorreu um erro`,
                    toaster: "b-toaster-top-center",
                    solid: true,
                    variant: "danger",
                  }
                );
              });
          })
          .catch(() => {
            this.$bvToast.toast(
              `Desculpe, tivemos algum problema. Por favor tente novamente!`,
              {
                title: `Ocorreu um erro`,
                toaster: "b-toaster-top-center",
                solid: true,
                variant: "danger",
              }
            );
          });
      }
    }
  }
};
</script>

<style lang="scss">
@import "src/styles/CorporateGroupCreate.scss";

.photo-gallery .gallery-photo-pending {
  background-color: #f8f9fa;
}
</style>